import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LessonsRoutingModule } from './lessons.routes';
import { SharedModule } from 'src/app/shared/shared.module';
import { LessonListComponent } from './components/lesson-list/lesson-list.component';
import { LessonDetailsComponent } from './components/lesson-details/lesson-details.component';
import { UpdateLessonComponent } from './components/update-lesson/update-lesson.component';
import { CreateLessonCurriculumComponent } from './components/create-lesson-curriculum/create-lesson-curriculum.component';
import { LessonCurriculumDetailsComponent } from './components/lesson-curriculum-details/lesson-curriculum-details.component';
import { EditLessonCurriculumComponent } from './components/edit-lesson-curriculum/edit-lesson-curriculum.component';
import { LessonsApiService } from './services/lessons-api.service';
import { LessonCurriculumApiService } from './services/lesson-curriculum-api.service';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';


@NgModule({
    declarations: [
        LessonListComponent,
        LessonDetailsComponent,
        UpdateLessonComponent,
        CreateLessonCurriculumComponent,
        EditLessonCurriculumComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        LessonsRoutingModule,
        FormsModule,
    ReactiveFormsModule,
    CKEditorModule,
    LessonCurriculumDetailsComponent,
    ],
    providers: [
        LessonsApiService,
        LessonCurriculumApiService,
    ],
    bootstrap: []
})
export class LessonModule { }
